import { z } from 'zod'

export const ADMINSESSIONGET_CONTRACT_VERSION = '1.0.0' as const
export const adminSessionGetResponseSchema = z.unknown()
export type AdminSessionGetResponse = z.infer<typeof adminSessionGetResponseSchema>
